import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { client } from 'rsui-core/lib/post-message';
import style from './style.vue';
import { typeList, COUPONS_TYPE } from './couponsList';
import areaList from './areaList';
import { EmpServiceAPIActions } from '@/services/empService';
import { noop } from '@/util';
import { IPSService } from '@/services/ipsServices';

@Component({
  mixins: [style],
})
export default class CouponCard extends Vue {
  static install() {
    Vue.component('CouponCard', CouponCard);
  }

  @Prop({ default: () => {} })
    data: ItemObject;

  @Prop()
    siteId: number;

  @Prop({ default: 0 })
    couponIndex: number;

  isLong = false;

  tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  mounted() {
    this.isLong = this.data.useEndTime === 2114352000;
  }

  conditionView() {
    const protocol = `${location.protocol}//`;
    let hostName = location.hostname;
    hostName.includes('host') && (hostName = 'ips.maintenance.qingger.cn');

    IPSService.siteGroupConfig({
      postParams: {
        sgId: +this.$route.params.sgId || +this.$route.params.id,
        siteId: this.siteId,
      },
    }).then((res) => {
      client
        .pick({
          path: 'customer-predicate',
          dialogStyle: { width: '50vw', height: '100vh', backgroudColor: '#eee', zIndex: 99999999999 },
          modelDialog: true,
          slide: 'left',
          props: {
            params: { actId: res.actId || 2 },
            zIndex: 99999999999,
            id: this.data.id,
            exclude: ['#root.crmPublicAccounts'],
            disable: true,
          },
          domain: `${protocol + hostName}/scrm/web`,
          cancel: true,
          search: `?baseURL=/nips/scrm&ext_ips__auth_token=${this.tokenData.Authorization}&ext_ips__site=${this.siteId}`,
        })
        .then((r: any) => {});
    });
  }

  rennderConponVal(h) {
    let result = <span class="coupon-value-no"></span>;
    switch (this.data.cplType) {
      case COUPONS_TYPE.ZHEKOU:
        result = <span class="coupon-value-no font-size-14">{this.data.cplVal}折</span>;
        break;
      case COUPONS_TYPE.JINE:
        result = (
          <span class="coupon-value-no">
            <span class="font-size-14">{this.data.cplType === 1 ? '￥' : ''}</span>
            {this.data.cplVal}
          </span>
        );
        break;
      case COUPONS_TYPE.LIPIN:
      case COUPONS_TYPE.DINGJIA:
      case COUPONS_TYPE.BAOYOU:
      case COUPONS_TYPE.TONGYONG:
      case COUPONS_TYPE.WAIBU:
        result = <span class="coupon-value-no font-size-24">{this.data.cplVal}券</span>;
        break;
      default:
        break;
    }
    return result;
  }

  areaList() {
    areaList.open({ dataList: this.data.receiptConfig.limitRegion.lalConfigInfo, disabled: true }).then(noop, noop);
  }

  // 原有逻辑不支持所有会员均可领取条件，所以加上this.data.isAll
  render(h) {
    return (
      <div class="coupon-info-box">
        <div
          class="fillet-bottom"
          style={{
            bottom:
              (this.data.tagConfig && this.data.tagConfig.tagName)
              || this.data.condition
              || this.data.isAll
              || !!(this.data.receiptConfig && this.data.receiptConfig.limitRegion && this.data.receiptConfig.limitRegion.lalConfigInfo && this.data.receiptConfig.limitRegion.lalConfigInfo.length)
                ? '34px'
                : '18px',
          }}
        />

        <div class="fillet-top" />
        <div class="dashed-line" />
        <div class="coupon-index">
          {this.couponIndex ? (
            <span class="font-size-24 oblique">{this.couponIndex}</span>
          ) : !this.data.gsciId ? (
            <i class="el-icon-remove font-size-24 cursor-pointer text-blue-15" onClick={() => this.$emit('remove')} style="top:calc(50% - 12px);" />
          ) : (
            ''
          )}
        </div>
        <div class="coupon-no">券型编号：{this.data.cplId}</div>
        <div class="coupon-info">
          <div class="coupon-title">{this.data.cplName}</div>
          <span class="coupon-type">{typeList[this.data.cplType]}</span>
          <div class="coupon-enable-time">
            有效期：
            {this.isLong ? (
              '永久'
            ) : (
              <span>
                {moment(this.data.pushBeginTime * 1000).format('YYYY-MM-DD HH:mm')}
                &nbsp;至&nbsp;
                {moment(this.data.pushEndTime * 1000).format('YYYY-MM-DD HH:mm')}
              </span>
            )}
          </div>
          <div class="coupon-value">
            {/* <span class="coupon-value-no">
              <span style="font-size: 14px">{this.data.cplType === 1 ? "￥" : ""}</span>
              {this.data.cplVal}
            </span> */}
            {this.rennderConponVal(h)}
            <div class="coupon-detail">详情&gt;</div>
          </div>
        </div>
        <div
          class="coupon-tag"
          style={{
            height:
              (this.data.tagConfig && this.data.tagConfig.tagName)
              || this.data.condition
              || this.data.isAll
              || !!(this.data.receiptConfig && this.data.receiptConfig.limitRegion && this.data.receiptConfig.limitRegion.lalConfigInfo && this.data.receiptConfig.limitRegion.lalConfigInfo.length)
                ? '40px'
                : '24px',
            lineHeight:
              (this.data.tagConfig && this.data.tagConfig.tagName)
              || this.data.condition
              || this.data.isAll
              || !!(this.data.receiptConfig && this.data.receiptConfig.limitRegion && this.data.receiptConfig.limitRegion.lalConfigInfo && this.data.receiptConfig.limitRegion.lalConfigInfo.length)
                ? '40px'
                : '24px',
          }}>
          {this.data.tagConfig && this.data.tagConfig.tagName && <span class="coupon-type">{this.data.tagConfig.tagName}</span>}
          {!!this.data.condition && (
            <span class="scopeSpan" onClick={() => this.conditionView()}>
              满足{this.data.condition}个条件方可领取
            </span>
          )}
          {!!this.data.isAll && <span class="condition">所有会员均可领取</span>}

          {!!(this.data.receiptConfig && this.data.receiptConfig.limitRegion && this.data.receiptConfig.limitRegion.lalConfigInfo && this.data.receiptConfig.limitRegion.lalConfigInfo.length) && (
            <span class="scopeSpan" onClick={() => this.areaList()}>
              {`${this.data.receiptConfig.limitRegion.lalConfigInfo.length}个地区${['可领取', '不可领取'][this.data.receiptConfig.limitRegion.configInLalType]}`}
            </span>
          )}
        </div>
      </div>
    );
  }
}
